var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3702_2744)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3702_2744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.75H21.75V5.25",
    stroke: "#4A7A8A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.663 18C16.4836 19.1128 15.0025 19.8535 13.4046 20.1294C11.8068 20.4052 10.163 20.2041 8.67881 19.5512C7.19459 18.8982 5.93569 17.8224 5.05942 16.458C4.18314 15.0937 3.72834 13.5014 3.75184 11.88C3.77535 10.2587 4.27612 8.68026 5.19157 7.3419C6.10703 6.00354 7.39659 4.96462 8.89912 4.35497C10.4016 3.74531 12.0505 3.59194 13.6397 3.91403C15.2289 4.23612 16.6879 5.01937 17.8345 6.16593L21.7505 9.75",
    stroke: "#4A7A8A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3702_2744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3702_2744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanIcon);
export default __webpack_public_path__ + "static/media/clean-icon.39af687b40b4f415830259dd2d2f48b5.svg";
export { ForwardRef as ReactComponent };